// eslint-disable-next-line import/no-unresolved
import { renderAsync } from 'docx-preview';

export class DocxPreviewer {
  public async render(
    dataUrl: string,
    content: HTMLElement,
    styles?: HTMLElement,
  ): Promise<void> {
    const arrayBuffer = DocxPreviewer.dataUrlToArrayBuffer(dataUrl);
    content.innerHTML = '';
    styles && (styles.innerHTML = '');
    await renderAsync(arrayBuffer, content, styles || content, {
      inWrapper: false,
      ignoreHeight: true,
    });
  }

  public clear(
    container: HTMLElement | null,
    content?: HTMLElement | null,
    styles?: HTMLElement | null,
  ) {
    if (content) {
      content.innerHTML = '';
    } else if (container) {
      container.innerHTML = '';
    }
    if (styles) {
      styles.innerHTML = '';
    }
    if (container) {
      container.style.display = 'none';
    }
  }

  private static dataUrlToArrayBuffer(dataUrl: string): ArrayBuffer {
    const base64 = dataUrl.split(',')[1] || '';
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
  }
}
